const getSession = (key: string): any => {
  if (sessionStorage.getItem(key)) {
    try {
      return sessionStorage.getItem(key)
    } catch (error) {
      sessionStorage.removeItem(key)
      throw error
    }
  }
}

const setSession = (key: string, value: any): void => {
  sessionStorage.setItem(key, value)
}

const removeSession = (key: string): void => {
  sessionStorage.removeItem(key)
}

export {
  getSession,
  setSession,
  removeSession
}